export const compareObjectsByProperties = (obj1, obj2, properties) => {
    if (!obj1 || !obj2 || !properties) {
        return false;
    }

    for (const prop of properties) {
        if (obj1[prop] !== obj2[prop]) {
            return false;
        }
    }
    return true;
};

export const isPlainObject = value => {
    if (Object.prototype.toString.call(value) !== '[object Object]') {
        return false;
    }
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};

export const areArraysOfObjectsEqual = (arr1 = [], arr2 = []) => {
    if (arr1.length !== arr2.length) {
        return false; // Arrays have different lengths
    }

    // Sort both arrays of objects to ensure consistent order
    const sortedArr1 = arr1.slice().sort();
    const sortedArr2 = arr2.slice().sort();

    for (let i = 0; i < sortedArr1.length; i++) {
        const obj1 = sortedArr1[i];
        const obj2 = sortedArr2[i];

        const keys1 = Object.keys(obj1).sort();
        const keys2 = Object.keys(obj2).sort();

        if (keys1.length !== keys2.length) {
            return false; // Objects have different numbers of keys
        }

        for (const key of keys1) {
            if (!keys2.includes(key)) {
                return false; // Objects have different keys
            }

            if (obj1[key] !== obj2[key]) {
                return false; // Values of corresponding keys are different
            }
        }
    }

    return true; // Arrays are the same
};
